// extracted by mini-css-extract-plugin
module.exports = {"all_equipment":"Equipment_all_equipment__2Zl8y","single_equipment":"Equipment_single_equipment__2eBxr"};